var Utils = {};

/**
 * naformatuje vstup (integer number) jako string s oddelenymi rady
 * @param val
 * @return {String}
 */
Utils.formatInteger = function(val){
	return val.toString().replace(/((?=(\d{7,9}))((\d{0,3})(\d{3})(\d{3}))|((\d{0,3})(\d{3})))$/g,'$4 $5 $6 $8 $9').replace(/(^\s*)|(\s*$)/g, '');
};

/**
 * naformatuje vstup (float number) jako string s oddelenymi rady
 * @param val
 * @param decimal: pocet desetinnych mist
 * @returns {string}
 */
Utils.formatFloat = function(val, decimal){
	var inputSplit = val.toString().replace(',','.').split('.'),
		separator,
		postfix;


	if ((inputSplit.length == 1) || (decimal == 0)) {
		separator = '';
		postfix = '';
	}
	else {
		separator = typeof window.projectConfig.lang != undefined && window.projectConfig.lang == 'cs' ? ',' : '.';
		postfix = inputSplit[1];
		if (inputSplit[1].length < decimal) {
			for (var i = 0; i < (decimal - inputSplit[1].length); i++) {
				postfix = postfix + '0';
			}
		}
	}

	return Utils.formatInteger(inputSplit[0]) + separator + postfix;
};


/**
 * zaokrouhli cislo number na dany pocet desetinnych mist
 * @param number
 * @param precision
 * @return {Number}
 */
Utils.round = function(number, precision){
	var val = precision!=undefined?Math.pow(10, precision):1;
	return Math.round(number*val)/val;
};

Utils.isInt = function(n){
	return Number(n) === n && n % 1 === 0;
};

Utils.isFloat = function(n){
	return Number(n) === n && n % 1 !== 0;
};

Utils.formatCurrency = function(val){
	if (Utils.isFloat(val)) {
		val = Utils.round(val,2);
		val = Utils.formatFloat(val,2);
	}
	else {
		val = Utils.formatInteger(val);
	}
	return val;
};

/**
 * detekuje dotykový display a vtátí true/false podle skutečnosti
 */
Utils.isTouchDevice = function() {
	return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
};

module.exports = Utils;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/utils.js